<script lang="ts">
    import DBG from "../code/DBG";
    import ProjectData from "../code/ProjectData";
    export let userEmail: string;

    function openDialog() {
        DBG.log(
            "LicenceExpired - openDialog, windows location",
            window.location
        );
        Office.context.ui.displayDialogAsync(
            window.location.origin + "/startAuth.html",
            (result) => {
                DBG.log("App - display dialog result:", result);
                result.value.addEventHandler(
                    Office.EventType.DialogMessageReceived,
                    (args) => {
                        DBG.log("App - DialogMessageReceived:", args);
                        result.value.close();
                    }
                );
                result.value.addEventHandler(
                    Office.EventType.DialogEventReceived,
                    (args) => {
                        DBG.log("App - DialogEventReceived:", args);
                        result.value.close();
                    }
                );
                result.value.addEventHandler(
                    Office.EventType.DialogParentMessageReceived,
                    (args) => {
                        DBG.log("App - DialogParentMessageReceived:", args);
                        result.value.close();
                    }
                );
            }
        );
    }

    function openAuthDialog() {
        DBG.log("UnauthPage - openAuthDialog");
        openDialog();
    }
</script>

<div class="row" id="unauth-main">
    <div class="col-md-6">
        <img
            src="img/logo.png"
            alt="Time-location add-in for Microsoft Project"
        />
        <p>
            To use the Time-location Microsoft Project add-in, you must have a
            valid licence.
        </p>
        {#if ProjectData.authUser}
            <p>Licence information:</p>
            <ul>
                <li>User: {ProjectData.authUser.Name} ({userEmail})</li>
                <li>Company: {ProjectData.authUser.Company}</li>
                <li>Licence type: {ProjectData.authUser.LicenceType}</li>
                <li>
                    Expiry date: {ProjectData.authUser.ValidTo.toLocaleDateString()}
                </li>
            </ul>
        {:else}
            <p>No licence associated to your user: {userEmail}.</p>
        {/if}

        <div class="button-holder" />
        <button type="button" class="btn btn-primary" on:click={openAuthDialog}
            >Log in</button
        >

        <hr />
        <p>Having trouble logging in?</p>
        <p>
            <i class="fa fa-envelope" />
            <a
                href="mailto:costin@4projects.ro, office@4projects.ro?subject=TLMSP support request"
                >Contact support</a
            >
        </p>
        <hr />
        <p class="mt-3">Interested in buying the TLMSP addin?</p>
        <p>
            <i class="fa fa-file-signature" />
            <a href="https://tlmsp.com" target="_blank">Use this form</a>
        </p>
    </div>
</div>

<style>
    #unauth-main {
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: tlmsp;
        padding: 1rem;
    }

    #unauth-main img {
        width: 100%;
        margin-top: 1rem;
        margin-bottom: 1rem;
    }

    @font-face {
        font-family: tlmsp;
        src: url(font/Microsoft\ Sans\ Serif.ttf);
    }

    .button-holder {
        display: flex;
        justify-content: center;
    }

    .btn-primary {
        background-color: #009cff;
        border-color: #009cff;
        color: #fff;
    }

    .btn-primary:hover {
        background-color: #031747;
        border-color: #031747;
        color: #fff;
    }
</style>
